import { useWizard } from "react-use-wizard";
import NavigateBack from "../../components/navigateBack";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const IntroStep = ({ fromLink = undefined }) => {
  const { nextStep } = useWizard();
  const history = useHistory();
  const { t } = useTranslation();

  const onClickFn = () => {
    history.push("/");
  };

  return (
    <>
      <NavigateBack onClickHandler={onClickFn} title={t("hi.title")} />
      <div className="body_content">
        <div className="inner_body">
          <h1 className="bigheadtitle">{t("hi.title")}</h1>
          <p className="txt_small mb-4">{t("hi.line1")}</p>
          <p className="desc mb-3">{t("hi.line2")}</p>
          <p className="desc mb-3">{t("hi.line3")}</p>
          <p className="desc">{t("hi.line4")}</p>
          <div className="btn_block bottom_button d-flex justify-content-center">
            <button className="btn btn_primary" onClick={() => nextStep()}>
              {t("hi.start")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default IntroStep;
